import React from 'react';

import { toMarkdown, toMarkdownInline } from '../../utils';

import { Value } from './markdown.styled';
import { MarkdownProps } from './markdown.types';

export const Markdown: React.FC<MarkdownProps> = (props: MarkdownProps): JSX.Element => {
  const { className, text, onClick = (): void => undefined, as }: MarkdownProps = props;

  return (
    <Value
      as={as}
      dangerouslySetInnerHTML={{ __html: as ? toMarkdownInline(text) : toMarkdown(text) }}
      className={className}
      onClick={onClick}
    />
  );
};
